import React from 'react';
import { useService } from 'hooks';
import {
  IGetArnReferenceDataRequest,
  IGetArnReferenceDataResponse
} from 'services/arnService/arnServiceTypes';
import useDampReportService from 'services/dampReportService/useDampReportService';

const getCountryListRequest: IGetArnReferenceDataRequest = {
  type: ['AUSTRALIAN_STATES',
    'TESTING_METHOD',
    'ALCOHOL_READING',
    'DAMP_PERMISSION_TYPE',
    'DAMP_TEST_REASON',
    'AGE_RANGE',
    'SSAA_TYPE',
    'STATE REGIONS',
    'SUBSTANCE_SUBJECT_POSITIVE_TO'],
  code: ['AUSTRALIAN_STATES',
    'TESTING_METHOD',
    'ALCOHOL_READING',
    'DAMP_PERMISSION_TYPE',
    'DAMP_TEST_REASON',
    'AGE_RANGE',
    'SSAA_TYPE',
    'STATE_REGIONS',
    'SUBSTANCE_SUBJECT_POSITIVE_TO']
};

interface IDampReportContextType {
  referenceDataResponse?: IGetArnReferenceDataResponse | null | undefined;
}

export const DampReportContext = React.createContext<IDampReportContextType>({} as IDampReportContextType);
interface IDampReportContextProviderProps {
  organisationId?: string;
}

export const DampReportContextProvider: React.FC<IDampReportContextProviderProps> = ({ organisationId, children }) => {
  const dampReportService = useDampReportService();
  const referenceDataResponse = useService<IGetArnReferenceDataResponse>(() => dampReportService.getArnReferenceData(getCountryListRequest));

  return (
    <DampReportContext.Provider value={{
      referenceDataResponse: referenceDataResponse,
    }}>
      {children}
    </DampReportContext.Provider>
  );
};